import Config from '../Config';
import EventsAPI from '../../common/api/events';
import AffiliateAPI from '../../common/api/affiliate';
import DestinationAPI from '../../common/api/destination';
import {apiResponseErrors, logAffiliateError} from './error-utils';

export const fetchDestinationId = async (affiliateCode, subAffiliateCode) => {
    try {
        const affiliateResponse = await AffiliateAPI.get(
            affiliateCode,
            subAffiliateCode
        );

        return affiliateResponse?.data?.data?.destination_id;
    } catch (error) {
        logAffiliateError(error, subAffiliateCode);

        // when subAffiliate API call fails try ONLY using the Affiliate code
        if (subAffiliateCode) {
            try {
                const affiliateResponse = await AffiliateAPI.get(affiliateCode);

                return affiliateResponse?.data?.data?.destination_id;
            } catch (affiliateError) {
                logAffiliateError(affiliateCode);
            }
        }

        return Config.destinationId;
    }
};

export const fetchEvents = async ({destinationId, pageSize}) => {
    try {
        const response = await EventsAPI.get({
            destinationId,
            pageSize,
        });

        return response?.data?.data?.results;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch events', error);

        return [];
    }
};

export const fetchDestinationName = async destinationId => {
    try {
        const response = await DestinationAPI.get(destinationId);

        return response?.data?.data?.title;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch destination details', error);

        return '';
    }
};

export const fetchData = async ({
    affiliateCode,
    subAffiliateCode,
    pageSize,
}) => {
    let destinationId = Config.destinationId;

    if (affiliateCode) {
        destinationId = await fetchDestinationId(
            affiliateCode,
            subAffiliateCode
        );
    } else {
        // eslint-disable-next-line no-console
        console.error(apiResponseErrors.noAffiliate);
    }

    const events = await fetchEvents({destinationId, pageSize});
    const destinationName = await fetchDestinationName(destinationId);

    return {
        destinationId,
        destinationName,
        events,
    };
};

export const getTrackingLink = (trackingLink = '') =>
    !trackingLink.includes('https://')
        ? decodeURIComponent(trackingLink)
        : trackingLink;
